import React,{useState, useEffect} from 'react'
//import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import EditPlanModal from './editPlanModal/EditPlanModal'

export default function DataTablePlugin(props) {

    const [openEditModel, setOpenEditModel] = useState(false)

    const [editAction, setEditAction] = useState({
        planningNum : "",
        station : "",
        part : "",
        tool : "",
        planningDate : "",
        qty : "",
        startDate : "",
        endDate : "",
        status : ""

     })

     console.log(editAction);

const columns = [
    {
        name: 'Planning Number',
        selector: row => row.planningId,
        width: "200px",
        sortable : true,
    },
    {
        name: 'Station',
        selector: row => row.machineId,
        sortable : true
    },
    {
        name: 'Part',
        selector: row => row.partId,
        sortable : true
    },
    {
        name: 'Tool',
        selector: row => row.toolId,
        sortable : true
    },
    {
        name: 'Planning Date',
        selector: row => (new Date(row.startDate)).toLocaleString("sv-SE"),
        width:"200px"
    },
    {
        name: 'Qty',
        selector: row => row.quantityPlanned,
        width:"100px",
        sortable : true
    },
    {
        name: 'Start Date',
        selector: row => (new Date(row.startDate)).toLocaleString("sv-SE"),
        sortable : true,
        width:"200px"
    },
    {
        name: 'End Date',
        selector: row => (new Date(row.endDate)).toLocaleString("sv-SE"),
        sortable : true,
        width:"200px"
    },
    {
        name: 'Status',
        selector: row => '-',
        width : "100px"
    },
    {
        name: 'Modified By',
        selector: row => 'admin'
    },
    {
        name: 'action',
        selector : row => <FontAwesomeIcon
        type="button"
        style={{ float: "right" }}
        icon={faEdit}
          onClick={()=> {
            setOpenEditModel(true)
             setEditAction({
                planningNum : row.planningId,
                station : row.machineId,
                part : row.partId,
                tool : row.toolId,
                planningDate : (new Date(row.startDate)).toLocaleString("sv-SE"),
                qty : row.quantityPlanned,
                startDate : (new Date(row.startDate)).toLocaleString("sv-SE"),
                endDate : (new Date(row.endDate)).toLocaleString("sv-SE"),
                status : '-'
             })
        }} aria-hidden="true"></FontAwesomeIcon>
    },
]; 



      

//   return (
//     <>
//     {/* REACT DATA-TABLE-PLUGIN */}
//     <div>
//         <DataTable
//         columns={columns}
//         data={props.searchedData}
//         pagination
//         striped ={true}
//         className='table'
//         // fixedHeader
//         fixedHeaderScrollHeight='450px'
//         subHeader
//         subHeaderComponent={
//         <input type="text"
//         placeholder='Search' 
//         className='w-25 form-control'
//         value={props.search}
//         onChange={(e)=> props.setSearch(e.target.value)} />
//         }
//         />   
//     </div> 
//     {openEditModel && <EditPlanModal closeEditModel={setOpenEditModel} editAction={editAction}/>}
//     </>
//   )
 }
